export interface ILicense {
  id: number;
  licenseQty: number;
  companyId: number;
  license: string;
  beginningDate: string;
  endingDate: string;
  comercialName: string;
  comercialEmail: string;
  code: string;
}

export class License implements ILicense {
  id: number;
  licenseQty: number;
  companyId: number;
  license: string;
  beginningDate: string;
  endingDate: string;
  comercialName: string;
  comercialEmail: string;
  code: string;

  constructor(
    id?: number,
    licenseQty?: number,
    companyId?: number,
    license?: string,
    beginningDate?: string,
    endingDate?: string,
    comercialName?: string,
    comercialEmail?: string,
    code?: string
  ) {
    this.id = id || 0;
    this.licenseQty = licenseQty || 0;
    this.companyId = companyId || 0;
    this.license = license || '';
    this.beginningDate = beginningDate || '';
    this.endingDate = endingDate || '';
    this.comercialName = comercialName || '';
    this.comercialEmail = comercialEmail || '';
    this.code = code || '';
  }
}
